import type { RuleNames } from "./feature-names";

/** Arabic names of the company rules and rule categories. Same keys as rules.fr.ts. */
export const rulesAr: RuleNames = {
  rules: {
    REFUND_OWNER_APPROVAL_ABOVE_RULE: "موافقة المالك فوق مبلغ",
    ID_IMAGE_RETENTION_RULE: "مدة الاحتفاظ بصور الهوية",
    FIRST_REPLY_TARGET_RULE: "مهلة الرد الأول",
    INTERIM_SUSPENSION_REVIEW_RULE: "مراجعة الإيقاف المؤقت",
    UNANSWERED_JOB_EXPIRY_RULE: "انتهاء صلاحية طلب دون رد",
    SUBSCRIPTION_GRACE_PERIOD_RULE: "مهلة السماح للاشتراك",
    STAFF_SESSION_INACTIVITY_RULE: "تسجيل الخروج بعد عدم النشاط",
  },
  categories: {
    payments: "المدفوعات",
    support: "الملفات",
    safety: "الثقة والأمان",
    onboarding: "التحقق",
    jobs: "الطلبات",
    access: "الوصول",
  },
};
